import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决两次访问相同路由地址报错
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/service'
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/views/login/index')
        },
        {
            path: '/service',
            component: () => import('@/views/service/index'),
            children: [
                {
                    path: '',
                    redirect: 'robot'
                },
                {
                    path: 'robot',
                    name: 'Robot',
                    component: () => import('@/views/service/robot')
                },
                {
                    path: 'knowledge-base',
                    name: 'KnowledgeBase',
                    component: () => import('@/views/service/knowledge-base')
                },
                {
                    path: 'evaluation',
                    name: 'Evaluation',
                    component: () => import('@/views/service/evaluation')
                },
                // 人工介入路由暂时隐藏
                // {
                //     path: 'intervention',
                //     name: 'Intervention',
                //     component: () => import('@/views/service/intervention')
                // },
                // 洞察页面暂时隐藏
                // {
                //     path: 'user-insight',
                //     name: 'UserInsight',
                //     component: () => import('@/views/service/user-insight')
                // },
                {
                    path: 'customer-detail',
                    name: 'CustomerDetail',
                    component: () => import('@/views/service/customer-detail')
                },
                {
                    path: 'customer-tiering-detail',
                    name: 'CustomerTieringDetail',
                    component: () => import('@/views/service/customer-detail/tiering-detail.vue')
                },
                {
                    path: 'plan-analysis',
                    name: 'PlanAnalysis',
                    component: () => import('@/views/service/customer-detail/plan-analysis.vue')
                },
                {
                    path: 'customer-info/:id',
                    name: 'CustomerInfo',
                    component: () => import('@/views/service/customer-detail/customer-info')
                },
                {
                    path: 'customer-update',
                    name: 'CustomerListUpdate',
                    component: () => import('@/views/service/customer-detail/customer-update.vue'),
                    meta: {
                        fullscreen: true
                    }
                },
                {
                    path: 'group-send-task-list',
                    name: 'GroupSendTaskList',
                    component: () => import('@/views/service/customer-detail/group-send-task-list')
                },
                {
                    path: 'aitalk',
                    redirect: 'juju-talk'
                },
                {
                    path: 'juju-talk',
                    name: 'JuJuTalk',
                    component: () => import('@/views/service/juju-talk')
                },
                {
                    path: 'group-chat',
                    name: 'GroupChat',
                    component: () => import('@/views/service/group-chat')
                },
                {
                    path: 'task',
                    name: 'Task',
                    component: () => import('@/views/service/task')
                },
                {
                    path: 'material-library',
                    name: 'MaterialLibrary',
                    component: () => import('@/components/jujufollow/material-library')
                },
                {
                    path: 'coupon-delivery-history',
                    name: 'CouponDeliveryHistory',
                    component: () => import('@/components/jujufollow/coupon-delivery-history')
                },
                {
                    path: 'quality-check',
                    name: 'QualityCheck',
                    component: () => import('@/views/service/quality-check')
                },
                {
                    path: 'quality-check-detail',
                    name: 'QualityCheckDetail',
                    component: () => import('@/views/service/quality-check-detail')
                },
                {
                    path: 'data',
                    name: 'Data',
                    component: () => import('@/views/service/data')
                },
            ]
        },
        {
            path: '/consumption-detail',
            name: 'ConsumptionDetail',
            component: () => import('@/views/consumption-detail/index.vue'),
            meta: {
                title: '桔豆消耗详情'
            }
        },
         // 404页面
         {
            path: '/notFound',
            name: 'NotFound',
            component: () => import('@/views/notfound/index')
        },
        {
            path: '*',
            redirect: '/notFound'
        }
    ]
})
